  // Project Images
  import pimg1 from "../images/project/work-1.png";
  import pimg2 from "../images/project/work-2.png";
  import pimg3 from "../images/project/work-3.png";
  import pimg4 from "../images/project/work-4.png";
  import pimg5 from "../images/project/work-5.png";
  import pimg6 from "../images/project/work-6.png";
  import pimg7 from "../images/project/work-7.png";
  import pimg8 from "../images/project/work-8.png";
  import pimg9 from "../images/project/work-9.png";
  import pimg10 from "../images/project/work-10.png";
  import pimg11 from "../images/project/work-11.png";
  import pimg12 from "../images/project/work-12.png";
  import pimg13 from "../images/project/work-13.png";
  import pimg14 from "../images/project/work-14.png";

  const Projects = [
    {
      id: "1",
      title: "Times Trinity",
      subtitle: "Commercial Property",
      slug: "times-trinity",
      pimg: pimg1,
      location: "Thaltej Shilaj",
      status: "ongoing",
    },
    {
      id: "2",
      title: "Wynn",
      subtitle: "Commercial Property",
      slug: "wynn",
      pimg: pimg2,
      location: "Sindhubhavan",
      status: "completed",
    },
    {
      id: "3",
      title: "Times 104",
      subtitle: "Residential Property",
      slug: "times-104",
      pimg: pimg3,
      location: "Rajpath Rangoli",
      status: "completed",
    },
    {
      id: "4",
      title: "Times Marvel",
      subtitle: "Commercial Property",
      slug: "times-marvel",
      pimg: pimg4,
      location: "Thaltej",
      status: "ongoing",
    },
    {
      id: "5",
      title: "Times 40",
      subtitle: "Residential Property",
      slug: "times-40",
      pimg: pimg5,
      location: "Rajpath",
      status: "completed",
    },
    {
      id: "6",
      title: "The Sovereign",
      subtitle: "Commercial Property",
      slug: "the-sovereign",
      pimg: pimg6,
      location: "Thaltej Shilaj",
      status: "ongoing",
    },
    {
      id: "7",
      title: "The Bellagio",
      subtitle: "Residential Property",
      slug: "the-bellagio",
      pimg: pimg7,
      location: "Iscon Ambli",
      status: "completed",
    },
    {
      id: "8",
      title: "The Beaumonde",
      subtitle: "Residential Property",
      slug: "the-beaumonde",
      pimg: pimg8,
      location: "Thaltej Shilaj",
      status: "ongoing",
    },
    {
      id: "9",
      title: "Swati Senor",
      subtitle: "Residential Property",
      slug: "swati-senor",
      pimg: pimg9,
      location: "Iscon Ambli",
      status: "completed",
    },
    {
      id: "10",
      title: "Swati Premier",
      subtitle: "Commercial Property",
      slug: "swati-premier",
      pimg: pimg10,
      location: "Link-in Road",
      status: "completed",
    },
    {
      id: "11",
      title: "Swati 18",
      subtitle: "Commercial Property",
      slug: "swati-18",
      pimg: pimg11,
      location: "Thaltej",
      status: "ongoing",
    },
    {
      id: "12",
      title: "Ikebana",
      subtitle: "Commercial Property",
      slug: "ikebana",
      pimg: pimg12,
      location: "Sindhubhavan",
      status: "completed",
    },
    {
      id: "13",
      title: "Skyzenia",
      subtitle: "Residential Property",
      slug: "skyzenia",
      pimg: pimg13,
      location: "Science Park",
      status: "ongoing",
    },
    {
      id: "14",
      title: "Z Luxuria",
      subtitle: "Commercial Property",
      slug: "z-luxuria",
      pimg: pimg14,
      location: "Thaltej",
      status: "completed",
    },
  ];

  export default Projects;
